
















































import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { FormFilterComponent } from '@/components/base/form-filter/form-filter.component';
import companiesApi from '@/api/companies.api';
import { mapGetters } from 'vuex';
import { AccountRole } from '@/entities/accounts/account-role.enum';
import OfficeSelect from '@/containers/account/offices/office-select.vue';
import {
    IDictionary,
    IFormControl,
    IGetLoginLogs,
    ICompany,
    IListItem,
    ICriterion,
    DateRangeMapper,
    ISite
} from '../../../../entities';
import * as types from '../../../../store/types';
import store from '@/store/store';

@Component({
    components: {
        'app-office-field': OfficeSelect
    },
    computed: mapGetters({
        companyPermissions: types.AUTH_HAS_COMPANY_PERMISSIONS,
        adminPermissions: types.AUTH_HAS_ADMIN_PERMISSIONS,
        superadminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS
    })
})
export default class AgentsCriteriaComponent extends FormFilterComponent {
    public companies: IListItem[] = [{ heading: 'All', value: null }];

    public formState: IDictionary<IFormControl> = {
        search: {
            key: 'search',
            label: 'Search',
            value: null,
            toCriterion: (value) => {
                return (
                    (value && {
                        field: 'search',
                        value: `%${value}%`,
                        operator: 'LIKE'
                    }) ||
                    null
                );
            }
        },
        companyId: {
            key: 'companyId',
            label: 'Office',
            value: null,
            toCriterion: (value) => {
                return (
                    (value && {
                        field: 'companyId',
                        value
                    }) ||
                    null
                );
            }
        },
        active: {
            key: 'active',
            label: 'Activated',
            value: null
        }
    };

    public statuses: IListItem[] = [
        {
            heading: 'All statuses',
            value: null
        },
        {
            heading: 'Suspended',
            value: false
        },
        {
            heading: 'Activated',
            value: true
        }
    ];

    public migrationOptions: IListItem[] = [
        {
            heading: 'All',
            value: null
        },
        {
            heading: 'Migrated',
            value: 'Migrated'
        },
        {
            heading: 'Not Migrated',
            value: 'None'
        }
    ];

    public created() {
        this._loadCompanies();

        this.doSearch();
    }

    public defaultFormValues(): IDictionary<any> {
        return {
            search: null,
            companyId: null,
            active: null
        };
    }



    public getQueryObject(formState: IDictionary<IFormControl>) {
        return this.toCriteria();
    }

    @Emit()
    public search(criteria: ICriterion[]) {
        // empty
    }

    private async _loadCompanies() {
        const hasAdminPermissions =
            store.getters[types.AUTH_HAS_ADMIN_PERMISSIONS];
        if (hasAdminPermissions) {
            const items = await companiesApi.list(false);
            const mapped = items.map((x) => {
                return { value: x.id, heading: x.officeName };
            });
            this.companies = [{ heading: 'All', value: null }, ...mapped];
        }
    }

    @Watch('$route')
    private onRouteChanged(val: string, oldVal: string) {
        this.doSearch();
    }
}
